<body>
    <div class="container-1">
        <!-- <h1>About Econet</h1> -->
        <p>Econet Wireless Zimbabwe is Zimbabwe's largest provider of telecommunications services, providing solutions in mobile and fixed wireless telephony, public payphones, internet access, and payment solutions.</p>
        
        <p>Econet launched its network on the 10th of July 1998 and listed on 17th September 1998. It is one of the largest companies on the Zimbabwe Stock Exchange in terms of market capitalization.</p>
        
        <p>The company continues to upgrade its network to carry more subscribers and further widen its geographical coverage, which is already the most extensive in Zimbabwe.</p>
        
        <p>Buddie Beatz has been a Caller Ring back tone brand for Econet and is now introducing a new service under the same brand to stream music through a mobile app, where customers get access to a large collection of music by Zimbabwean artists.</p>
        
        <p>The app will be available for Android and iOS, downloadable from the Play Store or App Store.</p>
    </div>
</body>
